module.exports = __webpack_public_path__ + "static/media/INDA.fb537bd2.png";